import React, { useEffect, useRef, useState } from 'react';
import { Leaf, Shield, Clock, Heart, Award, Sparkles } from 'lucide-react';

const engagements = [
  {
    icon: Leaf,
    title: "Produits Frais",
    description: "Ingrédients de qualité sélectionnés chaque jour"
  },
  {
    icon: Shield,
    title: "100% Halal",
    description: "Viandes certifiées halal garanties"
  },
  {
    icon: Clock,
    title: "Fait Maison",
    description: "Préparations fraîches à la commande"
  },
  {
    icon: Heart,
    title: "Passion",
    description: "L'amour du bon goût depuis notre création"
  },
  {
    icon: Award,
    title: "Qualité Premium",
    description: "Les meilleurs ingrédients pour nos recettes"
  },
  {
    icon: Sparkles,
    title: "Hygiène Irréprochable",
    description: "Normes strictes respectées au quotidien"
  }
];

const Engagements = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [count, setCount] = useState(0);
  const sectionRef = useRef(null);
  const targetCount = 15000;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Animated counter
  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const increment = targetCount / steps;
    const stepDuration = duration / steps;

    let currentCount = 0;
    const timer = setInterval(() => {
      currentCount += increment;
      if (currentCount >= targetCount) {
        setCount(targetCount);
        clearInterval(timer);
      } else {
        setCount(Math.floor(currentCount));
      }
    }, stepDuration);

    return () => clearInterval(timer);
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="py-24 bg-[#D4AF37]">
      <div className="container mx-auto px-4">
        {/* Counter Section */}
        <div className="text-center mb-16">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="text-7xl md:text-8xl font-black text-black mb-2" style={{ fontFamily: 'Crimson Text, serif' }}>
              +{count.toLocaleString('fr-FR')}
            </div>
            <p className="text-2xl font-bold text-black/80">Clients satisfaits</p>
          </div>
        </div>

        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl lg:text-6xl font-bold text-black mb-4"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            Nos <span className="text-white drop-shadow-lg">Engagements</span>
          </h2>
          <p className="text-xl text-black/80 max-w-2xl mx-auto">
            Ce qui fait notre différence et votre satisfaction
          </p>
        </div>

        {/* Engagements Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {engagements.map((engagement, index) => {
            const IconComponent = engagement.icon;
            return (
              <div
                key={index}
                className={`bg-black/10 backdrop-blur-sm p-6 rounded-xl hover:bg-black/20 transition-all duration-500 group ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-center space-x-4">
                  <div className="bg-black p-4 rounded-xl group-hover:scale-110 transition-transform duration-300">
                    <IconComponent size={28} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-1">
                      {engagement.title}
                    </h3>
                    <p className="text-black/70">{engagement.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Engagements;
